// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Menu } from 'semantic-ui-react';
// local
import { logout } from 'app/redux/actions/auth';
// css
import './HomeHeader.css';

class HomeHeader extends Component {
    onClickLogout = () => {
        this.props.dispatch(logout());
    };

    render() {
        const { account } = this.props.auth;
        return (
            <Menu id="home-header">
                <Menu.Item className="lead">
                    <span className="salvus-atas">SALVUS ATAS</span>&nbsp;&nbsp;|&nbsp;&nbsp;{account.client.name}
                </Menu.Item>
                <Menu.Item position="right" className="logout">
                    <span className="acc-name">{account.name}</span>
                    <span className="link bold" onClick={this.onClickLogout}>
                        Sair
                    </span>
                </Menu.Item>
            </Menu>
        );
    }
}

HomeHeader.propTypes = {
    auth: PropTypes.object,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    auth: state.auth,
});
export default connect(mapStateToProps)(HomeHeader);
